<template>
  <div>
    <div class="d-flex">
      <v-menu open-on-hover bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-2"
            color="channelbtn"
            dark
            depressed
            v-bind="attrs"
            v-on="on"
          >
            Add
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in addItems"
            :key="index"
            link
            @change="showAddContentDialog(item.action)"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        color="warning"
        class="mr-2"
        depressed
        @click="editContent"
        :disabled="btnDisabled"
      >
        Edit
      </v-btn>
      <v-btn
        color="error"
        depressed
        @click.stop="deleteConfirmDialog = true"
        :disabled="btnDisabled || btnRemoveDisabled"
      >
        Remove
      </v-btn>
      <v-btn icon class="ml-auto" depressed @click.stop="reload">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </div>
    <div class="mt-4">
      <v-card>
        <v-card-title>
          Contents
          <v-spacer></v-spacer>
        </v-card-title>
        <v-row class="mr-1 ml-1 pt-0 mb-5"
          ><v-col cols="6" sm="8">
            <v-combobox
              v-model="selectedCategory"
              :items="categories"
              item-text="text"
              item-value="id"
              label="Category"
              hide-details
              class="mr-3"
              @change="changedCategory"
              return-object
            >
              <template slot="selection" slot-scope="data">
                {{ data.item.category_name }}
                <div class="cate-info-text">
                  {{ data.item.category_info }}
                </div>
              </template>
              <template slot="item" slot-scope="data">
                {{ data.item.category_name }}
                <div class="cate-info-text">
                  {{ data.item.category_info }}
                </div>
              </template>
            </v-combobox>
          </v-col>
          <v-col cols="6" sm="4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-data-table
          v-if="loaded"
          :headers="headers"
          :items="contents"
          :search="search"
          :options="pageOptions"
          show-select
          :hide-default-footer="false"
          :single-select="singleSelect"
          v-model="selectedContent"
          @update:options="savePageOptions"
        >
          <template v-slot:[`item.created`]="{ item }">
            <div>
              {{ $moment(item.created_at).format("YYYY-MM-DD") }}
            </div>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div>
              <v-icon
                small
                v-if="
                  item.status.includes('UPLOADING') ||
                  item.status.includes('PENDING') ||
                  item.status.includes('OPTIMIZING')
                "
                >mdi-autorenew mdi-spin</v-icon
              >
              {{ showStatus(item.status) }}
            </div>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <div>
              <v-tooltip top v-if="item.status.includes('UPLOADING')">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mr-3"
                    small
                    icon
                    @click="abort(item.id)"
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon color="blue-grey" dark>
                      mdi-close-circle-outline
                    </v-icon></v-btn
                  >
                </template>
                <span class="caption">Conversion Progress</span>
              </v-tooltip>
              <v-tooltip top v-if="item.status.includes('OPTIMIZING')">
                <template v-slot:activator="{ on, attrs }">
                  <v-progress-circular
                    :rotate="-90"
                    :size="28"
                    :width="3"
                    :value="showOptimizingPercent(item.id)"
                    color="primary"
                    v-on="on"
                    v-bind="attrs"
                  >
                    {{ showOptimizingPercent(item.id) }}
                  </v-progress-circular>
                </template>
                <span class="caption">Converting </span>
              </v-tooltip>
              <div v-if="item.status.includes('COMPLETE')">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-3"
                      small
                      icon
                      @click="view(item.id)"
                      v-bind="attrs"
                      v-on="on"
                      ><v-icon color="blue-grey" dark>
                        mdi-television-play
                      </v-icon></v-btn
                    >
                  </template>
                  <span class="caption">Viewer</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-3"
                      small
                      icon
                      @click="openCodeDialog(item.id)"
                      v-bind="attrs"
                      v-on="on"
                      ><v-icon color="blue-grey" dark>
                        mdi-export-variant
                      </v-icon></v-btn
                    >
                  </template>
                  <span class="caption">Share</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-3"
                      small
                      icon
                      @click="openStaticDialog(item.id)"
                      v-bind="attrs"
                      v-on="on"
                      ><v-icon color="blue-grey" dark>
                        mdi-google-analytics
                      </v-icon></v-btn
                    >
                  </template>
                  <span class="caption">Statics</span>
                </v-tooltip>
              </div>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <!-- 컨텐츠 생성(업로드) 모달창 -->
    <v-dialog v-model="uploadDialog" width="600px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text"
            >Upload Video(s)</v-card-title
          >
          <div class="ml-auto">
            <v-btn icon @click="closeUploadDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7">
          <v-form ref="form2">
            <dropUploader
              v-on:uploadfile="dropUploadFile"
              text="Drag and drop Video Files (mp4, mov, wmv, avi, ts) or"
              type="video/mp4,video/x-ms-wmv,video/x-ms-asf,video/x-msvideo,,video/avi,video/quicktime,video/mov,video/MP2T"
              length="50"
              size="5120"
              multiple="true"
              width="400"
              :uploading="dropUploading"
            ></dropUploader>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- embed 모달 창 -->
    <v-dialog v-model="embedDialog" width="600px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">Embed Video</v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="closeEmbedDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-9 pb-0">
          <v-form ref="form3">
            <v-text-field
              v-model="stream_url"
              outlined
              name="input-7-4"
              label="Enter Youtube or Vimeo Url"
              :rules="[embedUrlRules]"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="channelbtn"
            class="mr-2 white--text"
            @click="embedVideo"
          >
            Save
          </v-btn>
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="closeEmbedDialog()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- code 모달 창 -->
    <v-dialog v-model="codeDialog" width="600px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">Code</v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="closeCodeDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7">
          <div class="d-flex pb-2">
            <div>Video Direct Url</div>
            <div v-show="videoCopied" class="red--text ml-auto mr-9">
              Copied!
            </div>
          </div>
          <v-text-field
            v-model="video_url"
            readonly
            outlined
            name="videoTextField"
            ref="videoTextField"
            append-outer-icon="mdi-content-copy"
            @click:append-outer="copyVideoUrl"
          ></v-text-field>
          <div class="d-flex pb-2">
            <div>Embed Tag</div>
            <div v-show="embedCopied" class="red--text ml-auto mr-9">
              Copied!
            </div>
          </div>

          <v-textarea
            v-model="embed_tag"
            readonly
            outlined
            ref="embedTextArea"
            name="embedTextArea"
            append-outer-icon="mdi-content-copy"
            @click:append-outer="copyEmbedTag"
          ></v-textarea>

          <v-radio-group v-model="embed_tag_mode" row class="pt-0 mt-0">
            <v-radio label="Responsive" value="responsive"></v-radio>
            <v-radio label="Fixed" value="fixed"></v-radio>
          </v-radio-group>

          <v-row class="pt-0 pb-0" v-if="embed_tag_mode == 'fixed'">
            <v-col cols="2" class="pr-0">
              <v-text-field
                v-model="embed_tag_fixed_width"
                outlined
                dense
                hide-details
                suffix="px"
                @focus="onFocusFixedSize('w')"
              ></v-text-field
            ></v-col>
            <v-col cols="1" class="pr-0 pl-0 text-center"
              ><v-icon style="vertical-align: -webkit-baseline-middle"
                >mdi-window-close</v-icon
              ></v-col
            >
            <v-col cols="2" class="pl-0"
              ><v-text-field
                v-model="embed_tag_fixed_height"
                outlined
                dense
                hide-details
                suffix="px"
                @focus="onFocusFixedSize('h')"
              ></v-text-field
            ></v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- 컨텐츠 삭제확인 모달창 -->
    <v-dialog v-model="deleteConfirmDialog" width="500">
      <v-card>
        <div color="error" class="d-flex pa-2 align-center error">
          <v-card-title class="headline white--text">Delete</v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="deleteConfirmDialog = false">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7">
          <v-icon small>mdi-alert-circle-outline</v-icon> Are you sure you want
          to delete the Content?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            class="mr-2 text-capitalize"
            @click="deleteContent(selectedContent[0].id)"
          >
            Delete
          </v-btn>
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="deleteConfirmDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 컨텐츠 통계 모달 창 -->
    <v-dialog v-model="staticsDialog" width="800px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">Statics</v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="closeStaticsDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text>
          <contentStatics
            :id="staticsContentId"
            :key="staticsKey"
          ></contentStatics>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  createFile,
  createContent,
  updateContent,
  deleteContent,
} from "../graphql/Mutation";
import { listContents, listCategories } from "../graphql/Query";
import { onUpdateContent } from "../graphql/Subscription";
import { mapState } from "vuex";

const dropUploader = () => import("@/components/DragAndDropUploader");
const contentStatics = () => import("@/components/ContentStatics");

export default {
  name: "ContentslList",
  components: {
    dropUploader,
    contentStatics,
  },
  data: () => ({
    loaded: false,
    // list
    search: "",
    channels: [],
    originalContents: [],
    contents: [],
    categories: [],
    selectedCategory: "",
    selectedContent: [],
    selectedContentForTag: {},
    singleSelect: true,
    deleteConfirmDialog: false,
    editContentDialog: false,
    uploadDialog: false,
    embedDialog: false,
    contentUsersDialog: false,
    contentCategoryDialog: false,
    quillUploadImageUrl: "",
    width: "",
    uploadSlideSuccess: false,
    dropUploading: false,
    uploadingProcess: [],
    pageOptions: {},
    headers: [
      { text: "author", value: "author", align: " d-none" },
      {
        text: "Title",
        align: "start",
        value: "title",
      },
      { text: "Date", value: "date" },
      { text: "Created", value: "created" },
      { text: "Status", value: "status" },
      { text: "Actions", value: "action", sortable: false },
    ],
    channel_categories: [],
    editInfo: "",
    addItems: [
      { title: "Upload Video(s)", action: "upload" },
      { title: "Embed Video", action: "embed" },
    ],
    stream_url: "",
    stream_mode: "",
    codeDialog: false,
    video_url: "",
    embed_tag_mode: "responsive",
    embed_tag_fixed_width: 1280,
    embed_tag_fixed_height: 720,
    videoCopied: false,
    embedCopied: false,
    staticsDialog: false,
    staticsContentId: "",
    staticsKey: 1,
    settingPixel: "",
  }),
  computed: {
    ...mapState(["uploadingContent"]),
    btnDisabled: function () {
      return this.selectedContent.length <= 0;
    },
    btnRemoveDisabled: function () {
      return (
        this.selectedContent[0].status.includes("OPTIMIZING") ||
        this.selectedContent[0].status.includes("PENDING") ||
        this.selectedContent[0].status.includes("UPLOADING")
      );
    },
    content: function () {
      if (this.selectedContent.length > 0) {
        return this.contents.find(
          (item) => item.id == this.selectedContent[0].id
        );
      } else {
        return {};
      }
    },
    selectedContentIndex: function () {
      // return 0;
      if (this.selectedContent.length > 0) {
        return this.contents.findIndex(
          (item) => item.id == this.selectedContent[0].id
        );
      } else {
        return -1;
      }
    },
    selectedCategoryIds: function () {
      return this.selectedCategory.map((cate) => cate.id);
    },
    embed_tag: function () {
      if (this.embed_tag_mode == "responsive") {
        const embed_tag_responsive = `<div style="padding-top:56.25%;position:relative;"><iframe src="${
          this.video_url
        }" title="${encodeURIComponent(
          this.selectedContentForTag.title
        )}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" style="position:absolute;top:0;left:0;width:100%;height:100%;" allowfullscreen scrolling="no"></iframe></div>`;
        return embed_tag_responsive;
      } else {
        const embed_tag_fixed = `<iframe src="${
          this.video_url
        }" title="${encodeURIComponent(
          this.selectedContentForTag.title
        )}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" width="${
          this.embed_tag_fixed_width
        }" height="${
          this.embed_tag_fixed_height
        }"; allowfullscreen scrolling="no"></iframe>`;
        return embed_tag_fixed;
      }
    },
  },
  watch: {
    // uploadingContent: {
    //   handler: function(newVal) {
    //     if (newVal.length > 0) {
    //       newVal.forEach(item => {
    //         const idx = this.contents.findIndex(
    //           content => content.id == item.file_id
    //         );
    //         if (idx > -1) {
    //         }
    //       });
    //     }
    //   },
    //   deep: true
    // }

    embed_tag_fixed_width: {
      handler: function (newVal) {
        if (this.settingPixel == "w")
          this.embed_tag_fixed_height = parseInt((9 * newVal) / 16);
      },
    },
    embed_tag_fixed_height: {
      handler: function (newVal) {
        if (this.settingPixel == "h")
          this.embed_tag_fixed_width = parseInt((16 * newVal) / 9);
      },
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      const from = this.$route.query.from;
      if (from == "edit") {
        this.pageOptions = this.$store.state.pageOptions;
        console.log("pageOptions", this.pageOptions);
      }
      this.contents = [];
      await this.getListContents(); // content.categories
      this.categories = [];
      await this.getListCategories();
      this.loaded = true;
    },
    code: function (id) {
      console.log(id);
    },
    view: function (id) {
      const url = process.env.VUE_APP_BASE_URL + "/video/" + id;
      window.open(url, "_blank");
    },
    openStaticDialog: function (id) {
      this.staticsContentId = id;
      this.staticsKey += 1;
      this.staticsDialog = true;
      console.log(id);
    },
    closeStaticsDialog: function () {
      this.staticsDialog = false;
      this.staticsContentId = "";
    },
    showOptimizingPercent(id) {
      const item = this.contents.find((item) => item.id == id);
      console.log("status", item.status);
      const percent = item.status.split(" ")[1];
      return percent;
    },
    showAddContentDialog(action) {
      /**
       * 업로드 비디오, 임베드 비디오 선택해서 보여주기
       */
      if (action == "upload") this.uploadDialog = true;
      if (action == "embed") this.embedDialog = true;
    },
    async abort(file_id) {
      // 업로드 프로세스 중단
      this.$store.dispatch("abortVideo", file_id);

      // 컨텐츠 정보 업데이트 (status => null, rate => null);
      const input = {
        id: file_id,
        status: "NO FILE",
        rate: "0",
      };

      this.$apollo
        .mutate({
          mutation: updateContent,
          variables: { input },
          fetchPolicy: "no-cache",
        })
        .catch((e) => {
          console.log("error", e);
        });

      this.$store.dispatch("logger", {
        menu: "Contents",
        level: "success",
        message: `Abort uploading video/content ${file_id}`,
      });
    },
    closeEmbedDialog() {
      this.$refs.form3.reset();
      this.$refs.form3.resetValidation();
      this.embedDialog = false;
    },
    closeUploadDialog() {
      this.$refs.form2.reset();
      this.$refs.form2.resetValidation();
      this.uploadDialog = false;
    },
    editContent() {
      if (this.selectedContent.length == 0) return null;
      this.$router.push({
        name: "Content",
        query: { content_id: this.selectedContent[0].id },
      });
    },

    dropUploadFile(event) {
      const uploadFiles = event;
      const files = uploadFiles;
      const promises = files.map((file) => this.uploadVideo(file));

      Promise.all(promises)
        .then((res) => {
          console.log("Promise All Clear!", res);
        })
        .catch((e) => {
          console.log("Promise failed", e);
        });
    },

    uploadVideo(file) {
      return new Promise((resolve, reject) => {
        // 컨텐츠 레코드 생성 (uuid)
        const name = file.name.slice(0, file.name.lastIndexOf("."));
        const input = {
          title: name,
          channel_id: this.$store.state.channelId,
          date: this.$moment().format("YYYY-MM-DD"),
          who: "anyone",
          when: "permanent",
          where: "anywhere",
          stream_mode: "video",
          status: "UPLOADING",
        };
        // 컨텐츠 DB등록
        this.$apollo
          .mutate({
            mutation: createContent,
            variables: { input },
            fetchPolicy: "no-cache",
          })
          .then((res) => {
            const content_id = res.data.createContent.id;
            const file_id = content_id;
            // contents목록에 추가
            // this.contents.unshift(res.data.createContent);
            console.log({ file_id });
            // 업로드 창 닫기
            this.closeUploadDialog();

            // 컨텐츠 업로드를 위해 presigned url 받기
            return this.$apollo.mutate({
              mutation: createFile,
              variables: {
                channel_id: this.$store.state.channelId,
                content_id: content_id,
                mode: "video",
                name: file.name,
                fileType: file.type,
                file_id: file_id,
              },
              fetchPolicy: "no-cache",
            });
          })
          .then((res) => {
            const uploadUrl = res.data.createFile.url;
            const file_id = res.data.createFile.file_id;
            const params = {
              mode: "start",
              file: file,
              file_id: file_id,
              file_name: file.name,
              url: uploadUrl,
            };
            this.$store.dispatch("uploadVideo", params);
            resolve(file_id);
          })
          .catch((e) => {
            console.log("error", e);
            reject(file);
          });
      });
    },
    async embedVideo() {
      if (!this.$refs.form3.validate()) return;

      console.log(this.strea_mode, this.stream_url);
      if (this.stream_url == "") {
        console.log("something wrong");
        return;
      }
      const input = {
        title: "Untitled",
        channel_id: this.$store.state.channelId,
        date: this.$moment().format("YYYY-MM-DD"),
        who: "anyone",
        when: "permanent",
        where: "anywhere",
        stream_mode: "embed",
        stream_url: this.stream_url,
        status: "COMPLETE",
      };
      // 컨텐츠 DB등록
      try {
        const { data } = await this.$apollo.mutate({
          mutation: createContent,
          variables: { input },
          fetchPolicy: "no-cache",
        });
        // contents목록에 추가
        this.contents.unshift(data.createContent);
        // 업로드 창 닫기
        this.closeEmbedDialog();
      } catch (e) {
        console.log(e);
      }
    },
    async deleteContent(id) {
      const input = {
        channel_id: this.$store.state.channelId,
        id: id,
      };

      console.log({ input });
      try {
        const { data } = await this.$apollo.mutate({
          mutation: deleteContent,
          variables: { input },
          fetchPolicy: "no-cache",
        });

        const cid = data.deleteContent.id;
        const idx = this.contents.findIndex((x) => x.id == cid);
        this.contents.splice(idx, 1);
        this.$store.dispatch("logger", {
          menu: "Contents",
          level: "success",
          message: `Delete content ${cid}`,
        });
      } catch (e) {
        console.log("[ContentList/deleteContent", e);
      }

      this.deleteConfirmDialog = false;
    },
    async getListContents() {
      const channel_id = this.$store.state.channelId;
      let allContents = []; // 전체 데이터를 담을 배열
      let nextToken = null; // 다음 페이지를 위한 토큰

      try {
        do {
          const { data } = await this.$apollo.query({
            query: listContents,
            variables: {
              channel_id: channel_id,
              nextToken: nextToken, // GraphQL 변수에 nextToken 전달
            },
            fetchPolicy: "no-cache",
          });

          // 기존 배열에 새로 받아온 아이템들을 추가
          allContents = [...allContents, ...data.listContents.items];
          // 다음 페이지 유무 확인 (API 응답 스키마에 맞춰 'nextToken' 변수명 확인 필요)
          nextToken = data.listContents.nextToken;
        } while (nextToken); // nextToken이 null이나 undefined가 될 때까지 반복

        // 누적된 전체 데이터로 필터링 및 정렬 수행
        this.contents = allContents.filter(
          (item) => item.status != "UPLOADING"
        );
        this.contents.sort((a, b) => (a.created_at < b.created_at ? 1 : -1));

        this.originalContents = [...this.contents];
        console.log("Total Contents Loaded:", this.contents.length);
      } catch (error) {
        console.error("Error fetching all contents:", error);
      }
    },
    async getListCategories() {
      // 채널 전체 카테고리가져오기
      const channel_id = this.$store.state.channelId;

      const { data } = await this.$apollo.query({
        query: listCategories,
        variables: {
          channel_id: channel_id,
        },
        fetchPolicy: "no-cache",
      });

      const categories = data.listCategories.items;

      categories.sort((a, b) => (a.category_name < b.category_name ? 1 : -1));
      categories.forEach((category) => {
        category.text = category.category_name + " - " + category.category_info;
        category.value = category.id;
      });
      const allCategory = {
        category_name: "All",
        category_info: "",
        id: "",
      };

      categories.unshift(allCategory);
      this.categories = categories;
      console.log("categories", categories);
    },
    ruleKey(v) {
      if (this.who == "key" && !v) return "Required.";
      if (this.who == "key" && v.length > 10)
        return "Key value must be less than 10 characters";
      return true;
    },
    updateWhoGroups(evt) {
      this.who_groups = evt;
    },
    updateCategoryList(evt) {
      this.channel_categories = evt;
      console.log(evt);
      this.checkSelectedCategory();
    },
    showStatus(status) {
      let rtnStatus = status;
      if (status.includes("UPLOADING")) rtnStatus = "UPLOADING";
      if (status.includes("PENDING")) rtnStatus = "PENDING";
      if (status.includes("PROGRESSING")) rtnStatus = "PROGRESSING";
      if (status.includes("OPTIMIZING")) rtnStatus = "OPTIMIZING";
      if (status.includes("COMPLETE")) rtnStatus = "COMPLETE";
      return rtnStatus;
    },
    embedUrlRules(v) {
      const youtubePattern =
        /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;
      const isYoutube = youtubePattern.test(v);

      const vimeoPattern =
        /(?:http:|https:|)\/\/(?:player.|www.)?vimeo\.com\/(?:video\/|embed\/|watch\?\S*v=|v\/)?(\d*)/;
      const isVimeo = vimeoPattern.test(v);

      if (isYoutube || isVimeo) {
        return true;
      } else {
        return "Url should be vaild.";
      }
    },
    openCodeDialog(id) {
      this.embed_tag_mode = "responsive";
      const url = process.env.VUE_APP_BASE_URL + "/video/" + id;
      this.video_url = url;
      this.codeDialog = true;

      this.selectedContentForTag = this.contents.find((item) => item.id == id);
    },
    closeCodeDialog() {
      this.video_url = "";
      // this.embed_tag = "";
      this.codeDialog = false;
    },
    onFocusFixedSize(d) {
      this.settingPixel = d;
      console.log(d);
    },
    copyVideoUrl() {
      const copyText = this.$refs.videoTextField.$el.querySelector("input");
      copyText.select();
      document.execCommand("copy");
      this.videoCopied = true;
      setTimeout(() => {
        this.videoCopied = false;
      }, 2000);
    },
    copyEmbedTag() {
      const copyText = this.$refs.embedTextArea.$el.querySelector("textarea");
      copyText.select();
      document.execCommand("copy");
      this.embedCopied = true;
      setTimeout(() => {
        this.embedCopied = false;
      }, 2000);
    },
    reload() {
      this.initialize();
    },
    savePageOptions(evt) {
      this.$store.commit("SET_PAGE_OPTIONS", evt);
      console.log("pageOptions", this.$store.state.pageOptions);
    },
    changedCategory(evt) {
      console.log(evt);
      this.filterCategory(evt);
    },
    filterCategory(categoryObj) {
      if (categoryObj) {
        if (categoryObj.id == "") {
          this.contents = [...this.originalContents];
        } else {
          const filteredArr = this.originalContents.filter(
            (item) =>
              item.categories && item.categories.includes(categoryObj.id)
          );
          this.contents = [...filteredArr];
        }
      } else {
        this.contents = [...this.originalContents];
      }
    },
  },
  apollo: {
    $subscribe: {
      onUpdateContent: {
        query: onUpdateContent,
        variables() {
          return {
            channel_id: this.$store.state.channelId,
          };
        },
        result(data) {
          const item = data.data.onUpdateContent;
          const id = item.id;
          const status = item.status;
          console.log("컨텐츠 구독 - 업데이트", data);

          // 찾아서 리스트 내에 있는 컨텐츠 변경
          const idx = this.contents.findIndex((item) => item.id == id);
          console.log(idx);
          if (idx > -1) {
            this.contents[idx].status = status;
          } else {
            // 업로딩이 완료되서 처음 리스트에 추가되는 상황
            console.log("hey1");
            this.contents.push(item);
            this.contents.sort((a, b) =>
              a.created_at < b.created_at ? 1 : -1
            );
          }

          console.log("구독결과 컨텐츠리스트 updateContent", data);
        },
        error(error) {
          console.error(error);
        },
      },
    },
  },
};
</script>

<style>
.file-chip {
  height: auto;
  white-space: normal;
}
.domain {
  text-transform: none !important;
}
.stream_mode_select {
  width: 150px;
}
.cate-info-text {
  font-size: 12px;
  color: rgb(146, 146, 146);
  padding-left: 5px;
}
</style>
